export default __webpack_public_path__ + "static/headshot1-73abb0dffd16cc673e51a7e6fffae3e7.png";